import { ColumnsType } from 'antd/es/table';
import { quarterlyUsers } from '../../../types';
import { Status } from '../../../components';
import { MenteeName } from '../../hr/employee-dashboard/columns';
import { Statuses } from '../../../helper';
import { formattedDateTime } from '../../../helper/functions';

export const assignedMenteescolumns = (
  fromMentor = true,
  quarterName: string,
  selectedCycleId: string
): ColumnsType => [
  {
    title: fromMentor ? 'Mentee' : 'Employee',
    key: 'name',
    render: (_, record: quarterlyUsers) => (
      <MenteeName
        //@ts-ignore
        data={{ ...record.user }}
        quarterName={quarterName}
        state={{
          from: 'mentor',
          selectedCycleId: selectedCycleId,
          isQuarter: true,
        }}
      />
    ),
    sorter: (a: quarterlyUsers, b: quarterlyUsers) => {
      return a.user?.name?.trim().localeCompare(b.user?.name?.trim());
    },
  },
  {
    title: 'Designation',
    dataIndex: 'user',
    key: 'designation',
    render: (user) => user?.designation,
    sorter: (a: quarterlyUsers, b: quarterlyUsers) => {
      return a.user?.designation
        ?.trim()
        .localeCompare(b.user?.designation?.trim());
    },
  },
  {
    title: 'Tier',
    dataIndex: 'user',
    key: 'tier',
    render: (user) => user?.tier,
    sorter: (a: quarterlyUsers, b: quarterlyUsers) =>
      Number(a.user?.tier) - Number(b.user?.tier),
  },
  {
    title: 'Mentor Name',
    dataIndex: 'user',
    key: 'mentor',
    render: (user) => user?.mentor?.name,
    sorter: (a: quarterlyUsers, b: quarterlyUsers) => {
      return a.user?.mentor?.name
        ?.trim()
        .localeCompare(b.user?.mentor?.name?.trim());
    },
  },
  {
    title: 'No. of Objectives Set',
    dataIndex: 'user',
    key: 'noOfObjectives',
    render: (user) => user?.objectiveCount,
    sorter: (a: quarterlyUsers, b: quarterlyUsers) =>
      Number(a.user?.objectiveCount) - Number(b.user?.objectiveCount),
  },
  {
    title: 'Mentor Status',
    dataIndex: 'mentorStatus',
    key: 'mentorStatus',
    sorter: (a: quarterlyUsers, b: quarterlyUsers) =>
      a.mentorStatus?.trim().localeCompare(b.mentorStatus?.trim()),
    render: (status, data) => {
      if (status === Statuses.Completed) {
        return (
          <>
            <Status status={status} />
            {data.mentorSubmissionDate && (
              <div className="w-fit">
                <p className="text-gray-500 bg-gray-100 rounded-lg text-sm text-center py-1 px-3">
                  On {formattedDateTime(data.mentorSubmissionDate)}
                </p>
              </div>
            )}
          </>
        );
      }
      return <Status status={status} />;
    },
  },
  {
    title: 'Mentee Status',
    dataIndex: 'menteeStatus',
    key: 'menteeStatus',
    sorter: (a: quarterlyUsers, b: quarterlyUsers) =>
      a.menteeStatus?.trim().localeCompare(b.menteeStatus?.trim()),
    render: (status, data) => {
      if (status === Statuses.Completed) {
        return (
          <>
            <Status status={status} />
            {data.menteeSubmissionDate && (
              <div className="w-fit">
                <p className="text-gray-500 bg-gray-100 rounded-lg text-sm text-center py-1 px-3">
                  On {formattedDateTime(data.menteeSubmissionDate)}
                </p>
              </div>
            )}
          </>
        );
      }
      return <Status status={status} />;
    },
  },
];
